import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5187102d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "outer" };
const _hoisted_2 = { class: "contents change-width" };
import StakingMenu from '@/components/organisms/main/staking/StakingMenu.vue';
import Dashboard from '@/components/organisms/main/staking/stakingdashboard/Dashboard.vue';
import Cancellation from '@/components/organisms/main/staking/stakingcancellation/Cancellation.vue';
import StakingRegister from '@/components/organisms/main/staking/register/Register.vue';
import History from '@/components/organisms/main/staking/history/History.vue';
import SystemUpdateBanner from '@/materials/atoms/SystemUpdateBanner.vue';
import { ref, computed } from 'vue';
import { useStakingList } from '@/logics/stakinglist';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean },
        userInfo: null
    },
    setup(__props) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const funds = ref([]);
            if (props.isAuth) {
                const { getStakingList } = useStakingList();
                funds.value = (([__temp, __restore] = _withAsyncContext(() => {
                    var _a;
                    return getStakingList(((_a = props.userInfo) === null || _a === void 0 ? void 0 : _a.id) || 0).catch((err) => {
                        console.error(err);
                        return [];
                    });
                })),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            else {
                funds.value = [];
            }
            const selectedTab = ref(funds.value.length !== 0 ? 'dashboard' : 'staking');
            const changeTab = (tab) => {
                selectedTab.value = tab;
            };
            // Compute whether to show the banner: only show before 2025/10/06 in any timezone
            const showBanner = computed(() => {
                const bannerEndDateUTC = Date.UTC(2025, 9, 6, 0, 0, 0, 0);
                const nowUTC = Date.now();
                return nowUTC < bannerEndDateUTC;
            });
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(StakingMenu, {
                        current: selectedTab.value,
                        onClick: changeTab,
                        class: "menus"
                    }, null, 8, ["current"]),
                    _createElementVNode("div", _hoisted_2, [
                        (_unref(showBanner) && (selectedTab.value === 'dashboard' || selectedTab.value === 'staking' || selectedTab.value === 'history'))
                            ? (_openBlock(), _createBlock(SystemUpdateBanner, { key: 0 }))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: _normalizeClass(["main", {
                                    'exclude-history': selectedTab.value === 'history',
                                }])
                        }, [
                            (selectedTab.value === 'dashboard')
                                ? (_openBlock(), _createBlock(Dashboard, {
                                    key: 0,
                                    "is-auth": props.isAuth
                                }, null, 8, ["is-auth"]))
                                : _createCommentVNode("", true),
                            (selectedTab.value === 'staking')
                                ? (_openBlock(), _createBlock(StakingRegister, {
                                    key: 1,
                                    "is-auth": props.isAuth,
                                    "user-info": __props.userInfo,
                                    onRegisterDone: changeTab
                                }, null, 8, ["is-auth", "user-info"]))
                                : _createCommentVNode("", true),
                            (selectedTab.value === 'cancel')
                                ? (_openBlock(), _createBlock(Cancellation, {
                                    key: 2,
                                    "is-auth": props.isAuth,
                                    userInfo: __props.userInfo
                                }, null, 8, ["is-auth", "userInfo"]))
                                : _createCommentVNode("", true),
                            (selectedTab.value === 'history')
                                ? (_openBlock(), _createBlock(History, {
                                    key: 3,
                                    "is-auth": props.isAuth,
                                    userInfo: __props.userInfo
                                }, null, 8, ["is-auth", "userInfo"]))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]));
            };
        });
    }
});
